import { SelectionChangedEvent } from "ag-grid-community";
import { INITIAL_ADHOC_HOLD_OF_CNTR_COL_DEF, transferRowData } from "presentation/constant/AdhocHoldOfContainer/AdhocHoldOfCntrColumnDefinition";
import { useAdhocHoldOfCntrVM } from "presentation/hook/AdhocHoldOfContainer/useAdhocHoldOfCntrVM";
import { useAdhocHoldOfCntrTracked } from "presentation/store/AdhocHoldOfContainer/AdhocHoldOfCntrProvider";
import NbisTable from "presentation/view/components/TableWrapper/NbisTable";
import { TableWrapper } from "presentation/view/components/TableWrapper/TableWrapper";
import { memo, useCallback, useEffect, useMemo, useRef, useState } from "react";


const AdhocHoldOfCntrTablePanel: React.FC = () => {
    const [adhocHoldOfCntrState] = useAdhocHoldOfCntrTracked();
    const adhocHoldOfCntrVM = useAdhocHoldOfCntrVM();
    const gridRef: any = useRef(null);
    const { adhocHoldDataList } = adhocHoldOfCntrState;
    const [showOverlay, setShowOverlay] = useState<boolean>(false);

    useEffect(() => {
        setShowOverlay(adhocHoldOfCntrState.isSearchLoading || (!adhocHoldOfCntrState.isSearchLoading &&
            adhocHoldDataList && adhocHoldDataList.length) ? false : true);
    }, [adhocHoldOfCntrState.isSearchLoading, adhocHoldDataList]);

    const handleSelectionChange = useCallback((e: SelectionChangedEvent) => {
        const selectedRows = e.api.getSelectedRows();

        adhocHoldOfCntrVM.updateSelectedRows(selectedRows);
    }, [adhocHoldOfCntrVM])

    const memoTable = useMemo(() => {
        return (
            <NbisTable
                id='adhoc-holc-table'
                isNewColumnSetting={true}
                columns={INITIAL_ADHOC_HOLD_OF_CNTR_COL_DEF.slice()}
                data={transferRowData(adhocHoldDataList ?? [])}
                showPaginator={false}
                editable={false}
                showAddIcon={false}
                showDeleteButton={false}
                showReloadIcon={false}
                isScrollHighlighted={true}
                selectionMode={false}
                rowSelection={"multiple"}
                isRowHighligted={true}
                handleSelectionChanged={handleSelectionChange}
                gridHeight="customHeight"
                customHeight="calc(100vh - 125px)"
                ref={gridRef}
                showDefaultOverlayNoRowsTemplate={showOverlay}
            />
        );
    }, [adhocHoldDataList, handleSelectionChange, showOverlay])

    return <>
        <TableWrapper>
            {memoTable}
        </TableWrapper>
    </>;
}

export default memo(AdhocHoldOfCntrTablePanel);
